<template>
  <vuestic-sidebar :hidden="isOpen">
    <template slot="menu">
      <sidebar-link :to="{ name: 'dashboard' }">
        <span slot="title" class="sidebar-menu-item-title">
          <span class="sidebar-menu-item-image">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 22.5 22.5"
              width="22.5px"
              height="22.5px"
            >
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                  <path class="cls-1" d="M0,0H5.46q0,2.73,0,5.46H0Z" />
                  <path class="cls-1" d="M0,8.53H5.46q0,2.73,0,5.46H0Z" />
                  <path
                    class="cls-1"
                    d="M0,17.05H5.46c0,1.81,0,3.63,0,5.45H0C0,20.69,0,18.87,0,17.05Z"
                  />
                  <path
                    class="cls-1"
                    d="M8.53,22.5c0-1.82,0-3.64,0-5.45H14c0,1.81,0,3.63,0,5.45Z"
                  />
                  <path class="cls-1" d="M17.05,22.5V17.05H22.5V22.5Z" />
                  <path
                    class="cls-1"
                    d="M14,2.74c0,.84,0,1.67,0,2.5,0,.15,0,.22-.2.22H8.71c-.14,0-.19,0-.19-.18q0-2.55,0-5.1c0-.15.05-.18.19-.18h5.07c.18,0,.2.06.2.21C14,1.06,14,1.9,14,2.74Z"
                  />
                  <path
                    class="cls-1"
                    d="M19.77,5.45H17.25c-.17,0-.2,0-.2-.21V0H22.5V5.25c0,.16,0,.21-.2.21Z"
                  />
                  <path
                    class="cls-1"
                    d="M11.26,8.53h2.51c.15,0,.21,0,.21.19,0,1.69,0,3.38,0,5.08,0,.13,0,.18-.18.18H8.7c-.15,0-.18-.05-.18-.18,0-1.7,0-3.39,0-5.08,0-.18.07-.2.22-.19Z"
                  />
                  <path
                    class="cls-1"
                    d="M19.75,14h-2.5c-.17,0-.2-.05-.2-.21V8.52H22.5v5.25c0,.16,0,.21-.2.21Z"
                  />
                </g>
              </g>
            </svg>
          </span>
          <span>{{ $t('menu.dashboard') }}</span>
        </span>
      </sidebar-link>
      <sidebar-link :to="{ name: 'all-customers' }" v-if="canCreate">
        <span slot="title">
          <span class="sidebar-menu-item-icon fa fa-users"></span>
          <span>{{ $t('menu.customers') }}</span>
        </span>
      </sidebar-link>
      <sidebar-link :to="{ name: 'all-extensions' }">
        <span slot="title" class="sidebar-menu-item-title">
          <span class="sidebar-menu-item-image">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 28.44 19.54"
              width="28.44"
              height="19.54"
            >
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                  <path
                    class="cls-1"
                    d="M5.3,19.51a2.72,2.72,0,0,1-1.08-.3C3.12,18.67.52,16.7.06,9.94-.51,1.51,3.32.29,3.76.18L4.51,0l.18,0H4.9a1.75,1.75,0,0,1,.75.17,1.7,1.7,0,0,1,.91,1.19l.27,3.3a1.65,1.65,0,0,1-.18.81,1.68,1.68,0,0,1-1.44,1H4.29C4,6.48,4,7.5,4,7.84l.3,3.66c.17.92.36,1.85.65,1.87l.91-.2H5.9a1.76,1.76,0,0,1,.76.17,1.7,1.7,0,0,1,.94,1.29l0,.14.24,3.12a1.68,1.68,0,0,1-.17.7,1.71,1.71,0,0,1-1.52.95ZM4.68,1,4,1.12C2.76,1.41.6,3.61,1,9.87c.48,7,3.34,8.65,4.3,8.67l.81,0a.74.74,0,0,0,.69-.41.63.63,0,0,0,.08-.27l-.26-3.13A.77.77,0,0,0,6,14.13l-.16,0L5,14.34c-1.16,0-1.4-1.34-1.65-2.71L3,7.87c0-.8.07-2.23,1.23-2.41h1a.74.74,0,0,0,.58-.41.64.64,0,0,0,.08-.35l.22-.1-.23,0L5.6,1.48A.7.7,0,0,0,5.22,1,.71.71,0,0,0,4.9,1H4.8L4.69.76Z"
                  />
                  <path
                    class="cls-1"
                    d="M7.63,17.91l-.24-3.12a.62.62,0,0,1,0-.13A1.49,1.49,0,0,0,5.84,13.4l-1,.2c-.42,0-.6-.69-.86-2.09l-.3-3.68c0-.93.14-1.57.56-1.63H5.2a1.5,1.5,0,0,0,1.25-.83,1.45,1.45,0,0,0,.15-.7.62.62,0,0,1,0-.12L6.34,1.4a1.44,1.44,0,0,0-.79-1A1.46,1.46,0,0,0,4.71.24l-.16,0L3.81.4C3.64.44-.29,1.48.29,9.92c.4,6,2.55,8.36,4,9.08a2.24,2.24,0,0,0,1,.28l.78,0a1.46,1.46,0,0,0,1.39-.82A1.32,1.32,0,0,0,7.63,17.91Zm-1.51.89-.8,0c-1,0-4-1.69-4.52-8.88C.36,3.48,2.65,1.2,3.92.9L4.64.77h.13a.87.87,0,0,1,.55.09.91.91,0,0,1,.51.63L6.08,4.6s0,.07,0,.09a1.06,1.06,0,0,1-.1.46,1,1,0,0,1-.79.54h-1c-1,.15-1,1.44-1,2.16l.31,3.74c.28,1.54.51,2.49,1.37,2.52l.86-.18.13,0H6a1,1,0,0,1,.91.82s0,.06,0,.1l.25,3.07a1.21,1.21,0,0,1-.1.36A1,1,0,0,1,6.12,18.8Z"
                  />
                  <path
                    class="cls-1"
                    d="M16.43,11A5.78,5.78,0,0,1,14.36,8.6a6.11,6.11,0,0,1,1.06-6.71,4.67,4.67,0,0,1,7,0,6.07,6.07,0,0,1-.78,9c-.22.16-.12.2,0,.29l5.54,3a2.06,2.06,0,0,1,1.17,2,8.66,8.66,0,0,1,0,1.44,2.06,2.06,0,0,1-2,1.69q-7.44,0-14.88,0a2.06,2.06,0,0,1-2-2.05q0-.57,0-1.14a2,2,0,0,1,1.1-1.85L16,11.29ZM19,18.33h7.43A1,1,0,0,0,27.5,17.2c0-.36,0-.72,0-1.08A1.13,1.13,0,0,0,26.84,15q-3.09-1.66-6.16-3.35a.57.57,0,0,0-.46,0,3.71,3.71,0,0,1-2.11.09,1.62,1.62,0,0,0-1.36.22Q13.9,13.47,11,15a1.08,1.08,0,0,0-.65,1.11c0,.33,0,.66,0,1,0,.86.36,1.22,1.22,1.22Zm-.34-7.47A4.17,4.17,0,0,0,22,9.46a5.51,5.51,0,0,0,.22-6.57A4,4,0,0,0,15.64,3a5.54,5.54,0,0,0,0,6.19A3.79,3.79,0,0,0,18.61,10.86Z"
                  />
                </g>
              </g>
            </svg>
          </span>
          <span>{{ $t('menu.extensions') }}</span>
        </span>
      </sidebar-link>
      <sidebar-link-group>
        <span slot="title" class="sidebar-menu-item-title">
          <span class="sidebar-menu-item-image">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20.51 26.24"
              width="20.51px"
              height="26.24px"
            >
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                  <path
                    class="cls-1"
                    d="M15.84,14.55H4.6a.24.24,0,0,1,0-.48H15.86a.23.23,0,0,1,.24.24A.25.25,0,0,1,15.84,14.55Z"
                  />
                  <path
                    class="cls-1"
                    d="M15.84,16.46H4.6a.24.24,0,0,1,0-.48H15.86a.23.23,0,0,1,.24.24A.25.25,0,0,1,15.84,16.46Z"
                  />
                  <path
                    class="cls-1"
                    d="M15.84,18.36H4.6a.22.22,0,0,1-.23-.23.22.22,0,0,1,.23-.24H15.86a.23.23,0,0,1,.24.24A.24.24,0,0,1,15.84,18.36Z"
                  />
                  <path
                    class="cls-1"
                    d="M15.84,20.27H4.6A.22.22,0,0,1,4.37,20a.22.22,0,0,1,.23-.23H15.86a.22.22,0,0,1,.24.23A.24.24,0,0,1,15.84,20.27Z"
                  />
                  <path
                    class="cls-1"
                    d="M15.84,22.18H4.6a.22.22,0,0,1-.23-.24.22.22,0,0,1,.23-.24H15.86a.23.23,0,0,1,.24.24A.24.24,0,0,1,15.84,22.18Z"
                  />
                  <path
                    class="cls-1"
                    d="M10.73,3.51V7.39h3.89A3.89,3.89,0,0,0,10.73,3.51Zm.48.52a3.45,3.45,0,0,1,2.91,2.89H11.21Z"
                  />
                  <path
                    class="cls-1"
                    d="M13,10.71,10.26,8.06V3.82H10a4.31,4.31,0,0,0,0,8.61A4.18,4.18,0,0,0,13,11.11l.22-.21ZM10,12a3.83,3.83,0,0,1-.17-7.65v4L12.57,11A3.85,3.85,0,0,1,10,12Z"
                  />
                  <path
                    class="cls-1"
                    d="M11,7.87l2.86,2.74A3.69,3.69,0,0,0,15,7.87Zm2.83,2.05L12.19,8.35h2.26A3.12,3.12,0,0,1,13.83,9.92Z"
                  />
                  <path
                    class="cls-1"
                    d="M2.5,25.86A2.21,2.21,0,0,1,.37,23.73V2.27A2,2,0,0,1,2.5.37H18.25a1.84,1.84,0,0,1,1.89,1.9V23.73a2,2,0,0,1-1.89,2.13ZM2.5.58A1.82,1.82,0,0,0,.58,2.27V23.73A2,2,0,0,0,2.5,25.66H18.25a1.83,1.83,0,0,0,1.68-1.93V2.27A1.61,1.61,0,0,0,18.25.58Z"
                  />
                  <path
                    class="cls-1"
                    d="M18.25,26.24H2.5A2.61,2.61,0,0,1,0,23.73V2.27A2.4,2.4,0,0,1,2.5,0H18.25a2.19,2.19,0,0,1,2.26,2.27V23.73A2.4,2.4,0,0,1,18.25,26.24ZM2.5,1A1.46,1.46,0,0,0,1,2.27V23.73A1.65,1.65,0,0,0,2.5,25.28H18.25a1.45,1.45,0,0,0,1.31-1.55V2.27A1.25,1.25,0,0,0,18.25,1Z"
                  />
                </g>
              </g>
            </svg>
          </span>
          <span>{{ $t('menu.reporting.title') }}</span>
        </span>
        <sidebar-link :to="{ name: 'call-reporting' }">
          <span slot="title" class="sidebar-menu-item-title">
            <span class="sidebar-menu-item-image">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20.46 17.06"
                width="20.46"
                height="17.06"
              >
                <g id="Layer_2" data-name="Layer 2">
                  <g id="Layer_1-2" data-name="Layer 1">
                    <path
                      class="cls-1"
                      d="M17.42,9.46h-7.3A.14.14,0,0,1,10,9.3a.14.14,0,0,1,.15-.15h7.32a.14.14,0,0,1,.15.15A.16.16,0,0,1,17.42,9.46Z"
                    />
                    <path
                      class="cls-1"
                      d="M17.42,10.7h-7.3a.14.14,0,0,1-.15-.16.14.14,0,0,1,.15-.15h7.32a.14.14,0,0,1,.15.15A.16.16,0,0,1,17.42,10.7Z"
                    />
                    <path
                      class="cls-1"
                      d="M17.42,11.94h-7.3a.14.14,0,0,1-.15-.16.14.14,0,0,1,.15-.15h7.32a.14.14,0,0,1,.15.15A.16.16,0,0,1,17.42,11.94Z"
                    />
                    <path
                      class="cls-1"
                      d="M17.42,13.18h-7.3A.14.14,0,0,1,10,13a.14.14,0,0,1,.15-.15h7.32a.14.14,0,0,1,.15.15A.16.16,0,0,1,17.42,13.18Z"
                    />
                    <path
                      class="cls-1"
                      d="M17.42,14.42h-7.3a.14.14,0,0,1-.15-.16.14.14,0,0,1,.15-.15h7.32a.14.14,0,0,1,.15.15A.16.16,0,0,1,17.42,14.42Z"
                    />
                    <path
                      class="cls-1"
                      d="M14.11,2.28V4.81h2.52A2.52,2.52,0,0,0,14.11,2.28Z"
                    />
                    <path
                      class="cls-1"
                      d="M13.59,7.78a2.49,2.49,0,0,1-.11-5V5.38L15.3,7.12A2.5,2.5,0,0,1,13.59,7.78Z"
                    />
                    <path
                      class="cls-1"
                      d="M14.28,5.12,16.14,6.9a2.41,2.41,0,0,0,.71-1.78Z"
                    />
                    <path
                      class="cls-1"
                      d="M4.31.31l-.13,0L3.53.39C3.4.42,0,1.11,0,8.29c0,5.71,2,7.49,2.88,8a2,2,0,0,0,.79.28l.68.07a1.14,1.14,0,0,0,1.15-.57,1.21,1.21,0,0,0,.15-.44l0-2.71v-.1A1.18,1.18,0,0,0,5,11.89a1.3,1.3,0,0,0-.56-.16l-.83.12h0c-.42-.07-.55-.63-.7-1.94l0-3.21c.08-.86.23-1.44.67-1.48l.8.06h0a1.16,1.16,0,0,0,1-.59,1,1,0,0,0,.16-.55V4.05l0-2.74A1.16,1.16,0,0,0,5,.47,1.18,1.18,0,0,0,4.31.31Z"
                    />
                    <path
                      class="cls-1"
                      d="M19,17.06H8.76a1.69,1.69,0,0,1-1.63-1.63v-14A1.56,1.56,0,0,1,8.76,0H19a1.42,1.42,0,0,1,1.47,1.47v14A1.56,1.56,0,0,1,19,17.06ZM8.76.62a1,1,0,0,0-1,.85v14a1.08,1.08,0,0,0,1,1H19a1,1,0,0,0,.85-1v-14A.8.8,0,0,0,19,.62Z"
                    />
                  </g>
                </g>
              </svg>
            </span>
            <span>Call Repoting</span>
          </span>
        </sidebar-link>
      </sidebar-link-group>
      <!-- <sidebar-link-group>
        <span slot="title" class="sidebar-menu-item-title">
          <span class="sidebar-menu-item-image">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 23.65 23.65"
              width="23.65px"
              height="23.65px"
            >
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                  <path
                    class="cls-1"
                    d="M16.12,6.35a.6.6,0,0,1-.62-.54h-.84a1.26,1.26,0,0,0,1,1.22v.52h.76V7a1.12,1.12,0,0,0,.73-.42,1.24,1.24,0,0,0,.28-.84A1.11,1.11,0,0,0,17,4.83a2,2,0,0,0-.71-.28,1.54,1.54,0,0,1-.62-.22.4.4,0,0,1,0-.55.57.57,0,0,1,.33-.11.43.43,0,0,1,.48.36v0h.84a.94.94,0,0,0-.26-.65A1.13,1.13,0,0,0,16.48,3V2.48h-.79V3a1.14,1.14,0,0,0-.69.42,1.21,1.21,0,0,0-.26.76,1,1,0,0,0,.42.89,3.44,3.44,0,0,0,1,.36.91.91,0,0,1,.37.18.38.38,0,0,1,.09.29.43.43,0,0,1-.13.34A.5.5,0,0,1,16.12,6.35Z"
                  />
                  <path
                    class="cls-1"
                    d="M0,4.86V23.23a.42.42,0,0,0,.42.42H15.63a.42.42,0,0,0,.42-.42v-3h5.28A2.32,2.32,0,0,0,23.65,18V.42A.42.42,0,0,0,23.23,0H8A.42.42,0,0,0,7.6.42V2.53H2.11a.47.47,0,0,0-.16,0A2.32,2.32,0,0,0,0,4.86ZM7.59,18h0a1.48,1.48,0,0,1-2.95,0V4.85a1.55,1.55,0,0,0,0-.37V4.43a1.89,1.89,0,0,0-.09-.34l0-.06a1.77,1.77,0,0,0-.15-.31l0-.05a1.94,1.94,0,0,0-.21-.29H7.6Zm13.74,1.47H7.92a1.94,1.94,0,0,0,.21-.29l0,0a1.87,1.87,0,0,0,.15-.32l0-.06a2,2,0,0,0,.09-.33v-.05a2.45,2.45,0,0,0,0-.38V.84H22.81V18a1.48,1.48,0,0,1-1.48,1.48ZM.84,4.86a1.48,1.48,0,1,1,3,0V18a2.33,2.33,0,0,0,2,2.29.45.45,0,0,0,.16,0H15.2v2.54H.84Z"
                  />
                  <path
                    class="cls-1"
                    d="M10.14,9.71a.42.42,0,0,0,.42.43H20.69a.43.43,0,1,0,0-.85H10.56A.42.42,0,0,0,10.14,9.71Z"
                  />
                  <path
                    class="cls-1"
                    d="M10.14,12.25a.42.42,0,0,0,.42.42H20.69a.42.42,0,0,0,.43-.42.42.42,0,0,0-.43-.42H10.56A.42.42,0,0,0,10.14,12.25Z"
                  />
                  <path
                    class="cls-1"
                    d="M10.14,14.78a.42.42,0,0,0,.42.42H20.69a.42.42,0,0,0,.43-.42.42.42,0,0,0-.43-.42H10.56A.42.42,0,0,0,10.14,14.78Z"
                  />
                </g>
              </g>
            </svg>
          </span>
          <span>{{ $t('menu.billing_account') }}</span>
        </span>
        <sidebar-link :to="{ name: 'billing-invoices' }">
          <span slot="title" class="sidebar-menu-item-title">
            <span class="sidebar-menu-item-image">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 15.45 18.66"
                width="15.45"
                height="18.66"
              >
                <g id="Layer_2" data-name="Layer 2">
                  <g id="Layer_1-2" data-name="Layer 1">
                    <path
                      class="cls-1"
                      d="M15.16,4.37h-1.9V2.48A.29.29,0,0,0,13,2.19H11.08V.29A.29.29,0,0,0,10.79,0H.29A.29.29,0,0,0,0,.29V14a.29.29,0,0,0,.29.29h1.9v1.9a.29.29,0,0,0,.29.29H4.37v1.9a.29.29,0,0,0,.29.29h10.5a.29.29,0,0,0,.29-.29V4.66A.29.29,0,0,0,15.16,4.37Zm-.29,13.7H5v-1.6h8a.29.29,0,0,0,.29-.29V5h1.61ZM.58.58h9.91V13.7H.58Zm2.19,13.7h8a.29.29,0,0,0,.29-.29V2.77h1.6V15.89H2.77Z"
                    />
                    <path
                      class="cls-1"
                      d="M2,6.08l.17.13a1.51,1.51,0,0,0,.29.13,1.37,1.37,0,0,0,.29.07l.07,0v.42A.16.16,0,0,0,3,7h.32a.15.15,0,0,0,.15-.15V6.41a1.38,1.38,0,0,0,.7-.32,1.08,1.08,0,0,0,.18-.24,1.12,1.12,0,0,0,.12-.53,1.2,1.2,0,0,0-.12-.55,1.3,1.3,0,0,0-.18-.23,2.36,2.36,0,0,0-.9-.47,1.63,1.63,0,0,1-.5-.25l0,0a.44.44,0,0,1-.14-.34.54.54,0,0,1,.13-.37l.05,0a.65.65,0,0,1,.37-.1.51.51,0,0,1,.41.17.69.69,0,0,1,.15.37.16.16,0,0,0,0,.1.17.17,0,0,0,.11,0h.43a.21.21,0,0,0,.12,0,.14.14,0,0,0,0-.14,1.18,1.18,0,0,0-.22-.66l0-.06a1,1,0,0,0-.28-.23,1.59,1.59,0,0,0-.42-.14V1.9a.15.15,0,0,0-.15-.15H3a.15.15,0,0,0-.15.15v.45a1.25,1.25,0,0,0-.66.29l-.06,0a1.07,1.07,0,0,0-.29.76,1,1,0,0,0,.31.78l0,0a1.64,1.64,0,0,0,.29.2l.29.13L3,4.7A1.66,1.66,0,0,1,3.52,5a.47.47,0,0,1,.15.35.44.44,0,0,1-.16.37A.66.66,0,0,1,3,5.83a.79.79,0,0,1-.32-.06.54.54,0,0,1-.15-.09.46.46,0,0,1-.14-.21.85.85,0,0,1,0-.17v0a.17.17,0,0,0,0-.11.16.16,0,0,0-.11,0H1.81a.18.18,0,0,0-.12,0,.17.17,0,0,0,0,.14A1,1,0,0,0,2,6.08Z"
                    />
                    <path
                      class="cls-1"
                      d="M1.92,8.75H9.13a.3.3,0,1,0,0-.59H1.92a.3.3,0,0,0,0,.59Z"
                    />
                    <path
                      class="cls-1"
                      d="M5.88,7H9.13a.3.3,0,1,0,0-.59H5.88a.3.3,0,0,0,0,.59Z"
                    />
                    <path
                      class="cls-1"
                      d="M5.88,5.25H9.13A.29.29,0,0,0,9.43,5a.3.3,0,0,0-.3-.3H5.88a.3.3,0,0,0-.29.3A.29.29,0,0,0,5.88,5.25Z"
                    />
                    <path
                      class="cls-1"
                      d="M5.88,3.5H9.13a.29.29,0,1,0,0-.58H5.88a.29.29,0,0,0,0,.58Z"
                    />
                    <path
                      class="cls-1"
                      d="M1.92,10.49H9.13a.29.29,0,1,0,0-.58H1.92a.29.29,0,0,0,0,.58Z"
                    />
                    <path
                      class="cls-1"
                      d="M2.48,12.24H6a.29.29,0,1,0,0-.58h-4a.29.29,0,0,0,0,.58h.56Z"
                    />
                  </g>
                </g>
              </svg>
            </span>
            <span>{{ $t('menu.billing.invoices') }}</span>
          </span>
        </sidebar-link> -->
      <!-- <sidebar-link :to="{ name: 'billing-refill' }">
          <span slot="title" class="sidebar-menu-item-title">
            <span class="sidebar-menu-item-image">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 17.38 22.44"
                width="17.38"
                height="22.44"
              >
                <g id="Layer_2" data-name="Layer 2">
                  <g id="Layer_1-2" data-name="Layer 1">
                    <path
                      class="cls-1"
                      d="M16.93,0H.46A.45.45,0,0,0,0,.45V22a.47.47,0,0,0,.46.47H16.93a.47.47,0,0,0,.45-.47V.45A.45.45,0,0,0,16.93,0Zm-.46,21.51H.91V.91H16.47Z"
                    />
                    <path
                      class="cls-1"
                      d="M3.09,9.55a2.69,2.69,0,0,0,.27.2,2.31,2.31,0,0,0,.45.21,2.12,2.12,0,0,0,.45.11l.12,0v.66a.24.24,0,0,0,.24.24h.51a.24.24,0,0,0,.24-.24v-.69a2,2,0,0,0,1.09-.5,1.44,1.44,0,0,0,.28-.37,1.89,1.89,0,0,0,0-1.69,1.25,1.25,0,0,0-.28-.37,3.78,3.78,0,0,0-1.41-.74A3.05,3.05,0,0,1,4.26,6L4.2,6A.71.71,0,0,1,4,5.41a.81.81,0,0,1,.21-.58l.07,0a1,1,0,0,1,.59-.16.82.82,0,0,1,.65.27,1,1,0,0,1,.22.57.25.25,0,0,0,.07.16A.19.19,0,0,0,6,5.68h.67a.33.33,0,0,0,.19,0,.22.22,0,0,0,.06-.21,1.94,1.94,0,0,0-.36-1l-.07-.1A1.7,1.7,0,0,0,6,3.93a2.08,2.08,0,0,0-.65-.23V3a.23.23,0,0,0-.24-.23H4.62A.23.23,0,0,0,4.38,3v.71a2,2,0,0,0-1,.46l-.09.07a1.66,1.66,0,0,0-.47,1.2,1.61,1.61,0,0,0,.49,1.23l.07.06a2.52,2.52,0,0,0,.45.3,4.71,4.71,0,0,0,.45.22c.14,0,.29.11.45.15a2.26,2.26,0,0,1,.82.43.72.72,0,0,1,.23.55.73.73,0,0,1-.25.58,1.15,1.15,0,0,1-.74.22,1.36,1.36,0,0,1-.51-.1A1.09,1.09,0,0,1,4,8.92a.71.71,0,0,1-.22-.33,1.07,1.07,0,0,1-.06-.27v0a.23.23,0,0,0-.05-.17.3.3,0,0,0-.18,0H2.84a.32.32,0,0,0-.19,0,.24.24,0,0,0-.07.21A1.7,1.7,0,0,0,3.09,9.55Z"
                    />
                    <path
                      class="cls-1"
                      d="M3,13.73H14.34a.46.46,0,0,0,0-.91H3a.46.46,0,1,0,0,.91Z"
                    />
                    <path
                      class="cls-1"
                      d="M9.23,11h5.11a.46.46,0,0,0,0-.92H9.23a.46.46,0,1,0,0,.92Z"
                    />
                    <path
                      class="cls-1"
                      d="M9.23,8.24h5.11a.46.46,0,0,0,0-.92H9.23a.46.46,0,1,0,0,.92Z"
                    />
                    <path
                      class="cls-1"
                      d="M9.23,5.49h5.11a.46.46,0,0,0,0-.91H9.23a.46.46,0,1,0,0,.91Z"
                    />
                    <path
                      class="cls-1"
                      d="M3,16.48H14.34a.46.46,0,0,0,0-.92H3a.46.46,0,0,0,0,.92Z"
                    />
                    <path
                      class="cls-1"
                      d="M3.88,19.23H9.36a.47.47,0,0,0,.46-.46.46.46,0,0,0-.46-.46H3a.45.45,0,0,0-.46.46.46.46,0,0,0,.46.46h.87Z"
                    />
                  </g>
                </g>
              </svg>
            </span>
            <span>{{ $t('menu.billing.refill') }}</span>
          </span>
        </sidebar-link>
        <sidebar-link :to="{ name: 'billing-charges' }">
          <span slot="title" class="sidebar-menu-item-title">
            <span class="sidebar-menu-item-image">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 17.38 22.44"
                width="17.38"
                height="22.44"
              >
                <g id="Layer_2" data-name="Layer 2">
                  <g id="Layer_1-2" data-name="Layer 1">
                    <path
                      class="cls-1"
                      d="M16.93,0H.46A.45.45,0,0,0,0,.45V22a.47.47,0,0,0,.46.47H16.93a.47.47,0,0,0,.45-.47V.45A.45.45,0,0,0,16.93,0Zm-.46,21.51H.91V.91H16.47Z"
                    />
                    <path
                      class="cls-1"
                      d="M3,13.73H14.34a.46.46,0,0,0,0-.91H3a.46.46,0,1,0,0,.91Z"
                    />
                    <path
                      class="cls-1"
                      d="M12.23,10.57h2.11a.46.46,0,0,0,0-.91H12.23a.46.46,0,1,0,0,.91Z"
                    />
                    <path
                      class="cls-1"
                      d="M12.23,7.82h2.11a.46.46,0,0,0,0-.91H12.23a.46.46,0,1,0,0,.91Z"
                    />
                    <path
                      class="cls-1"
                      d="M12.23,5.08h2.11a.46.46,0,0,0,0-.92H12.23a.46.46,0,0,0,0,.92Z"
                    />
                    <path
                      class="cls-1"
                      d="M3,16.48H14.34a.46.46,0,0,0,0-.92H3a.46.46,0,0,0,0,.92Z"
                    />
                    <path
                      class="cls-1"
                      d="M3.88,19.23H9.36a.47.47,0,0,0,.46-.46.46.46,0,0,0-.46-.46H3a.45.45,0,0,0-.46.46.46.46,0,0,0,.46.46h.87Z"
                    />
                    <path
                      class="cls-1"
                      d="M2.33,6.86a.2.2,0,0,1,.2-.09h.34c0-.26.07-.52.13-.77A3.9,3.9,0,0,1,4.38,3.85a3.87,3.87,0,0,1,4.54-.2A3.76,3.76,0,0,1,10.6,6.06a3.81,3.81,0,0,1-.7,3.21,3.76,3.76,0,0,1-2.2,1.44,4,4,0,0,1-3.63-1c-.11-.11-.11-.17,0-.28l.32-.33c.11-.1.17-.1.27,0a3,3,0,0,0,4.13.12,2.92,2.92,0,0,0,1-1.84A3.07,3.07,0,0,0,4,5.59,3,3,0,0,0,3.74,6.7v.07H4.1c.07,0,.14,0,.17.09s0,.13,0,.19l-.73.84A.27.27,0,0,1,3.42,8a.14.14,0,0,1-.23,0l-.71-.82L2.33,7Zm5-.17c0-.05,0-.07,0-.11L8.66,5.25l.06-.06A.14.14,0,0,0,8.63,5,.18.18,0,0,0,8.48,5c-.45.44-.9.89-1.34,1.34A.12.12,0,0,1,7,6.4a.43.43,0,0,0-.4,0,.09.09,0,0,1-.13,0l-.8-.79a.19.19,0,0,0-.14-.07.19.19,0,0,0-.11.09.16.16,0,0,0,0,.17l.81.8a.1.1,0,0,1,0,.12.55.55,0,0,0,.5.77A.56.56,0,0,0,7.3,6.69Zm-.23.23a.28.28,0,1,1-.27-.28A.27.27,0,0,1,7.07,6.92Z"
                    />
                  </g>
                </g>
              </svg>
            </span>
            <span>{{ $t('menu.billing.charges') }}</span>
          </span>
        </sidebar-link> -->
      <!-- </sidebar-link-group> -->
      <sidebar-link :href="pbxUrl" :external="true" target="_blank">
        <span slot="title" class="sidebar-menu-item-title">
          <span class="sidebar-menu-item-image">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 22.57 24.88"
              width="22.57px"
              height="24.88px"
            >
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                  <path
                    class="cls-1"
                    d="M10.56,12.76a1.37,1.37,0,1,0,1.36,1.36A1.36,1.36,0,0,0,10.56,12.76Zm0,1.79a.43.43,0,0,1-.46-.43.47.47,0,0,1,.93,0A.44.44,0,0,1,10.56,14.55Z"
                  />
                  <path
                    class="cls-1"
                    d="M22.13,11.22,17.41,8.08h-.16a.73.73,0,0,0-.72.73v1l-.06.22H16V1.28A1.28,1.28,0,0,0,14.75,0H1.27A1.29,1.29,0,0,0,0,1.28V20.52A1.29,1.29,0,0,0,1.22,21.8l11.06,3.05.17,0a1.29,1.29,0,0,0,1.27-1.28V21.8h1A1.28,1.28,0,0,0,16,20.52V14.31l.06-.22h.44V15.3a.73.73,0,0,0,.72.73h.15l4.77-3.12a.75.75,0,0,0,.4-.62v-.41A.73.73,0,0,0,22.13,11.22ZM12.66,23.9,1.38,20.78l-.09,0H1V1.19L1.19,1,12.34,4.1l.09,0h.27Zm5.24-9.41-.35.26v-.66h0v-1H14.2v1H15l0,6.69H13.72V4.36A1.29,1.29,0,0,0,12.5,3.08L6.66,1.47,6.72,1l8.29,0V10H14.2v1h3.36V9.41l4,2.67Z"
                  />
                </g>
              </g>
            </svg>
          </span>
          <span>{{ $t('menu.pbxware_access') }}</span>
        </span>
      </sidebar-link>
      <sidebar-link :to="{ name: 'conference-bridge' }">
        <span slot="title" class="sidebar-menu-item-title">
          <span class="sidebar-menu-item-image">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 21.44 13.47"
              width="21.44"
              height="13.47"
            >
              <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                  <path
                    class="cls-1"
                    d="M18,13.47a.72.72,0,0,1-.32-.08.62.62,0,0,1-.3-.43l0-2.37v-.06a.8.8,0,0,1,.09-.3A.65.65,0,0,1,18,9.91h0l.73.05c.81-.07.91-1.09,1-1.66l0-2.83c-.14-1.23-.27-2-1-2L18,3.51h-.14a.67.67,0,0,1-.56-.59V2.86l0-2.31a.46.46,0,0,1,.08-.23A.63.63,0,0,1,18,0l.61.06c.74.07,2.86,1.47,2.84,6.83,0,4.78-1.8,6.34-2.74,6.5l-.6.07Z"
                  />
                  <path
                    class="cls-1"
                    d="M3.38,0h.05a.62.62,0,0,1,.32.09.6.6,0,0,1,.3.42l0,2.37V3A.75.75,0,0,1,4,3.24a.63.63,0,0,1-.53.32h0l-.73-.05c-.81.07-.91,1.1-1,1.66L1.78,8c.14,1.22.27,2,1,2.05l.65-.1h.14a.66.66,0,0,1,.56.59v.06l0,2.32a.61.61,0,0,1-.09.23.63.63,0,0,1-.62.31l-.61-.07C2.1,13.34,0,11.94,0,6.58,0,1.79,1.8.23,2.74.07L3.34,0Z"
                  />
                  <path
                    class="cls-1"
                    d="M10.62,9a2.29,2.29,0,1,1,2.14-1.5A2.26,2.26,0,0,1,10.62,9Z"
                  />
                  <rect
                    class="cls-1"
                    x="5.99"
                    y="5.95"
                    width="1.03"
                    height="1.55"
                  />
                  <rect
                    class="cls-1"
                    x="14.22"
                    y="5.95"
                    width="1.03"
                    height="1.55"
                  />
                  <rect
                    class="cls-1"
                    x="16.27"
                    y="5.95"
                    width="1.03"
                    height="1.55"
                  />
                  <rect
                    class="cls-1"
                    x="3.44"
                    y="5.95"
                    width="1.03"
                    height="1.55"
                  />
                </g>
              </g>
            </svg>
          </span>
          <span>{{ $t('menu.conferenceBridge.title') }}</span>
        </span>
      </sidebar-link>
    </template>
  </vuestic-sidebar>
</template>

<script>
import VuesticSidebar from '../../../vuestic-theme/vuestic-components/vuestic-sidebar/VuesticSidebar'
import SidebarLink from './components/SidebarLink'
import SidebarLinkGroup from './components/SidebarLinkGroup'
import router from '../../../router'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'app-sidebar',
  components: {
    VuesticSidebar,
    SidebarLink,
    SidebarLinkGroup
  },
  data() {
    return {
      canCreate: false
    }
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(['tenantID', 'pbxUrl'])
  },
  methods: {
    ...mapActions(['fetchPBXUrl']),
    logout() {
      this.$store.dispatch('logout')
    }
  },
  created() {
    if (!this.pbxUrl) {
      this.fetchPBXUrl()
    }
  }
}
</script>
<style lang="scss">
.sidebar-link {
  a {
    .sidebar-menu-item-title {
      display: flex;
      align-items: center;
      .sidebar-menu-item-image {
        width: 30px;
        margin-right: 10px;
        text-align: center;
        svg {
          fill: $blue;
        }
      }
    }
    &.router-link-active,
    &:hover {
      .sidebar-menu-item-title {
        .sidebar-menu-item-image {
          svg {
            fill: $white;
          }
        }
      }
    }
  }
}
</style>
